import React, { useEffect, useState } from 'react';
import './previousPregnancyDetails.css';
import BadgesComponent from '@components/common/Badges';
import { getData } from '@services/CommonApiService';
import { useParams } from 'react-router-dom';
import endpoints from '@config/endpoints';
import dayjs from 'dayjs';
import { dateFormate } from '@constants/index';
import Button from '@components/common/Button';
import { useDispatch } from 'react-redux';
import {setLifeCalendarPagePreviousPragnancy } from '@store/actions/beneficiaryAction';
import DataTable from '@components/common/CommonDataTable';

const PreviousPregnancyDetails = () => {
  const [previousPregnancyDetails, setPreviousPregnancyDetails] = useState<any>([]);
  const { id } = useParams();
  const dispatch = useDispatch();
  const [gridData, setGridData] = useState<any>([]);

  useEffect(() => {
    const fetchData = async () => {
      const prevPregDetailsResponse = await getData<any>(`${endpoints.getPreviousPregnancyDetailsByBenefId}/${id}`);
      setPreviousPregnancyDetails(prevPregDetailsResponse?.data?.[0]);
      formatData(prevPregDetailsResponse?.data?.[0]);
    };
    fetchData();
  }, []);

  const formatData = (data: any) => {
    const formattedData = data?.pregnancy_closure_details
      ?.filter((item: any) => item?.pregnancy_closure_reason_id)
      ?.map((item: any) => ({
        pregnancy_closure_reason: item?.pregnancy_closure_reason_name === "Is Delivery outside JANANI"
          ? "Delivery"
          : "Abortion",
        pregnancy_closure_date: dayjs(item?.pregnancy_closure_date).format(dateFormate.dd_mm_yyyy),
      }))
      ?.sort((a: any, b: any) => {
        const dateA = dayjs(a.pregnancy_closure_date, dateFormate.dd_mm_yyyy).toDate().getTime();
        const dateB = dayjs(b.pregnancy_closure_date, dateFormate.dd_mm_yyyy).toDate().getTime();
        return dateB - dateA;
      });
    setGridData(formattedData);
  }

  const Columnheader = [
    {
      name: 'Pregnancy Closure Reason',
      key: 'pregnancy_closure_reason',
      sortable: false,
      width: 180,
    },
    {
      name: 'Pregnancy Closure Date',
      key: 'pregnancy_closure_date',
      sortable: true,
      width: 180,
    },
  ];

  const handleBackClick = () => {
    dispatch(setLifeCalendarPagePreviousPragnancy(false));
  };

  return (
    <div className="previous_pregnancy_details_overview">
      <Button
        onClick={handleBackClick}
        buttonName="Back"
        colorType="primary"
        dataTestId="prev-preg-back-button"
        id="prev-preg-back-button"
      />
      <BadgesComponent
        className="over-badge"
        badgeName="Children Details"
        variant="primary-1"
        badgeType="case5"
      />
      <div className="overview-details">
        <div>
          <label className="overview-details-label">Total Child</label>
          <div className="overview-details-value">
            {previousPregnancyDetails?.total_children_count || '-'}
          </div>
        </div>
        <div>
          <label className="overview-details-label">
            Female Child
          </label>
          <div className="overview-details-value">
            {previousPregnancyDetails?.female_children_count || '-'}
          </div>
        </div>
      </div>
      <div className='child-detail-bottom-line'></div>
      <BadgesComponent
        className="over-badge"
        badgeName="Previous Pregnancy Closure Details"
        variant="primary-1"
        badgeType="case5"
      />
      <div className="pregnancy-closure-table">
        <DataTable
          data={gridData}
          itemsPerPage={[10, 20, 30, 40, 50]}
          searchTerm={''}
          height={'300px'}
          columnHeader={Columnheader}
          gridFor={'Beneficiary'}
        />
      </div>
    </div >
  );
};

export default PreviousPregnancyDetails;